import "core-js/modules/es.array.push.js";
import { mapState } from 'vuex';
import Bus from '@/assets/js/bus.js';
export default {
  data() {
    return {
      pushTalkEnable: false,
      participantsEnable: false,
      muteAduio: false,
      activeName: '1',
      groupArray: [],
      assignInput: '',
      controlParticipantTimer: null,
      moveParticipantTimer: null,
      allGroupArray: [],
      inputGroupName: '',
      createGroupInfo: {
        show: false,
        title: 'pushTalk.createGroup',
        save: 'pushTalk.create',
        cancel: 'start.cancel'
      },
      participantNameInput: '',
      participantList: [],
      selectParticipantList: []
    };
  },
  props: {
    initOperateData: {
      type: Object,
      default: () => {}
    },
    tabVal: {
      type: String,
      default: ''
    }
  },
  created() {
    // 至少有两个开关处于打开且其中一个包含pushToTalk时
    const enabledCount = [this.State.initPushToTalk, this.State.initAudioMatrixEnable, this.State.initIntercomEnable].filter(Boolean).length;
    if (enabledCount >= 2 && this.State.initPushToTalk) {
      this.changePushTalk(false, 'noMessage');
      this.pushTalkEnable = false;
    }
    Bus.$on('setLoginScreenButton', val => {
      const {
        buttonType,
        operationType
      } = val.buttonStatus;
      if (buttonType === 15) {
        this.pushTalkEnable = operationType === 1;
      } else if (buttonType === 16) {
        this.participantsEnable = operationType === 1;
      } else if (buttonType === 20) {
        this.muteAduio = operationType === 1;
      }
    });
  },
  computed: {
    ...mapState({
      State: state => state
    })
  },
  watch: {
    'initOperateData.pushToTalk': {
      handler: function (newValue) {
        if (newValue) {
          this.pushTalkEnable = true;
        }
      },
      immediate: true
    },
    'initOperateData.pipPushToTalk': {
      handler: function (newValue) {
        if (newValue) {
          this.participantsEnable = true;
        }
      },
      immediate: true
    },
    'initOperateData.disableTalkInvokeAm': {
      handler: function (newValue) {
        if (newValue) {
          this.muteAduio = true;
        }
      },
      immediate: true
    },
    tabVal: {
      handler(val) {
        if (val === '8') {
          this.getAllGroup();
        }
      },
      immediate: true
    }
  },
  methods: {
    showMutexTip() {
      if (this.State.audioMatrixEnable || this.State.intercomEnable) {
        this.$emit('mutexTip');
      }
    },
    getAllGroup() {
      if (!this.State.partyJoinInfo.joinCode) return;
      this.groupArray = [];
      this.allGroupArray = [];
      this.State.shortCutArray = {};
      const params = {
        partyCode: this.State.partyJoinInfo.joinCode,
        startRtilCode: this.State.partyJoinInfo.rtilCode
      };
      this.axios.post('/partyline-backend/pushToTalk/noLogin/groupList', params).then(res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          const globalNameKeys = Object.keys(this.State.globalNameInfo).map(item => Number(item));
          result.forEach((item, index) => {
            item.activeName = [];
            item.edit = false;
            item.reName = '';
            item.select = false;
            item.rtilCodeList = item.rtilCodeList || [];
            item.rtilCodeList = item.rtilCodeList.filter(rtilCode => {
              return rtilCode !== this.State.partyJoinInfo.rtilCode && rtilCode != this.State.outputCode;
            });
            item.rtilCodeList.unshift(this.State.partyJoinInfo.rtilCode);
            item.rtilCodeList = item.rtilCodeList.filter(rtilCode => globalNameKeys.includes(rtilCode));
            item.allRtilCodes = this.State.allRtilCodes;
            this.$set(this.State.shortCutArray, index < 9 ? index + 1 : 0, item);
          });
          this.groupArray = result;
          this.allGroupArray = result;
          this.State.groupList = result;
        }
      }).catch(e => {
        console.log(e);
      });
    },
    saveCreateGroup() {
      this.$refs.createGroupDialog.allowClose = true;
      this.createGroup(this.selectParticipantList.filter(item => item.hasSelect).map(item => item.rtilCode));
      // this.addParticipant(this.inputGroupName, this.selectParticipantList.filter(item => item.hasSelect).map(item => item.rtilCode))
    },

    showCreateGroupBox(selectRtilCode) {
      this.participantList = [];
      this.inputGroupName = 'Group' + ' ' + (this.groupArray.length + 1);
      this.participantNameInput = '';
      this.createGroupInfo.show = true;
      this.State.allRtilCodes.forEach(rtilCode => {
        const obj = {};
        obj.rtilCode = rtilCode;
        if (rtilCode) {
          obj.hasSelect = selectRtilCode == rtilCode;
        } else {
          if (rtilCode == this.State.partyJoinInfo.rtilCode) {
            obj.hasSelect = true;
          } else {
            obj.hasSelect = false;
          }
        }
        this.participantList.push(obj);
        this.selectParticipantList = this.participantList;
      });
    },
    createGroup(rtilCodeList) {
      const params = {
        groupName: this.inputGroupName || 'Group' + ' ' + (this.groupArray.length + 1),
        partyCode: this.State.partyJoinInfo.joinCode,
        startRtilCode: this.State.partyJoinInfo.rtilCode,
        rtilCodeList: rtilCodeList
      };
      this.axios.post('/partyline-backend/pushToTalk/noLogin/createGroup', params).then(res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          result.talk = false;
          this.groupArray.push(result);
        }
        this.getAllGroup();
      }).catch(e => {
        console.log(e);
      });
    },
    changePushTalk(val, noMessage) {
      this.State.pushTalkEnable = val;
      if (!this.State.partyJoinInfo.joinCode) return;
      if (this.State.audioMatrixEnable) {
        this.$message.error(this.$t('pushTalk.notAllowed'));
        this.pushTalkEnable = false;
        return;
      }
      const params = {
        buttonType: 15,
        operationType: val ? 1 : 0,
        data: {
          hostRtilCode: this.State.partyJoinInfo.rtilCode
        }
      };
      this.axios.post(`/partyline-backend/partyAction/button?partyCode=${this.State.partyJoinInfo.joinCode}`, params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.State.pushTalkOpen = val;
          if (!noMessage) {
            this.$message.success(this.$t('commonFunction.operateSuccessful'));
          }
        }
      });
    },
    changeParticipantPushTalk(val, type) {
      if (!this.State.partyJoinInfo.joinCode) return;
      const params = {
        buttonType: type == 'pipEnable' ? 16 : 20,
        operationType: val ? 1 : 0,
        data: {
          hostRtilCode: this.State.partyJoinInfo.rtilCode
        }
      };
      this.axios.post(`/partyline-backend/partyAction/button?partyCode=${this.State.partyJoinInfo.joinCode}`, params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.$message.success(this.$t('commonFunction.operateSuccessful'));
        }
      });
    },
    deleteGroup(item, index) {
      this.$confirm(this.$t('pushTalk.deleteGroupText'), this.$t('pushTalk.deleteGroup'), {
        confirmButtonText: this.$t('pushTalk.delete'),
        cancelButtonText: this.$t('start.cancel'),
        type: 'warning'
      }).then(() => {
        const params = {
          groupName: item.groupName,
          partyCode: this.State.partyJoinInfo.joinCode,
          startRtilCode: this.State.partyJoinInfo.rtilCode,
          id: item.id
        };
        this.axios.post('/partyline-backend/pushToTalk/noLogin/removeGroupInfo', params).then(res => {
          if (res.data.errorCode === '0x0') {
            this.groupArray.splice(index, 1);
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    showGroupEdit(item, index) {
      item.edit = true;
      item.reName = item.groupName;
      this.$nextTick(() => {
        this.$refs[`renameInput${index}`][0].$refs.input.focus();
        this.$refs[`renameInput${index}`][0].$refs.input.select();
      });
    },
    saveGroupName(item) {
      if (!this.State.partyJoinInfo.joinCode) return;
      const params = {
        groupName: item.reName,
        partyCode: this.State.partyJoinInfo.joinCode,
        startRtilCode: this.State.partyJoinInfo.rtilCode,
        oldGroupName: item.groupName,
        id: item.id
      };
      this.axios.post('/partyline-backend/pushToTalk/noLogin/updateGroupName', params).then(res => {
        if (res.data.errorCode === '0x0') {
          item.groupName = item.reName;
          item.edit = false;
          this.$message.success(this.$t('commonFunction.operateSuccessful'));
        }
      });
    },
    participantsSort(item) {
      if (!item.allRtilCodes) return;
      item.allRtilCodes = item.allRtilCodes.sort((rtilCode1, rtilCode2) => {
        const val1 = item.rtilCodeList.includes(rtilCode1) ? 1 : 0;
        const val2 = item.rtilCodeList.includes(rtilCode2) ? 1 : 0;
        return val2 - val1;
      });
    },
    saveParticipantList(item) {
      if (item.rtilCode == this.State.partyJoinInfo.rtilCode) return;
      item.hasSelect = !item.hasSelect;
    },
    controlParticipant(item, rtilCode) {
      if (rtilCode == this.State.partyJoinInfo.rtilCode) return;
      if (item.rtilCodeList.includes(rtilCode)) {
        item.rtilCodeList = item.rtilCodeList.filter(item => item !== rtilCode);
        this.removeParticipant(item, rtilCode, 'notNeedConfirm');
      } else {
        item.rtilCodeList.push(rtilCode);
      }
      if (this.controlParticipantTimer) clearTimeout(this.controlParticipantTimer);
      this.controlParticipantTimer = setTimeout(() => {
        this.addParticipant(item.groupName, item.rtilCodeList, item);
      }, 1500);
    },
    addParticipant(groupName, rtilCodeList, item) {
      const params = {
        groupName: groupName,
        partyCode: this.State.partyJoinInfo.joinCode,
        startRtilCode: this.State.partyJoinInfo.rtilCode,
        rtilCodeList: rtilCodeList,
        id: item.id
      };
      this.axios.post('/partyline-backend/pushToTalk/noLogin/batchAddRtilCode', params).then(res => {
        if (res.data.errorCode === '0x0') {}
      });
    },
    removeParticipant(item, rtilCode, notNeedConfirm) {
      if (notNeedConfirm) {
        const params = {
          groupName: item.groupName,
          partyCode: this.State.partyJoinInfo.joinCode,
          startRtilCode: this.State.partyJoinInfo.rtilCode,
          rtilCode,
          id: item.id
        };
        this.axios.post('/partyline-backend/pushToTalk/noLogin/removeGroupInfo', params).then(res => {
          if (res.data.errorCode === '0x0') {
            item.rtilCodeList = item.rtilCodeList.filter(item => item !== rtilCode);
          }
        });
      } else {
        this.$confirm(this.$t('pushTalk.deleteParticipantText'), this.$t('pushTalk.deleteParticipant'), {
          confirmButtonText: this.$t('pushTalk.delete'),
          cancelButtonText: this.$t('start.cancel'),
          type: 'warning'
        }).then(() => {
          const params = {
            groupName: item.groupName,
            partyCode: this.State.partyJoinInfo.joinCode,
            startRtilCode: this.State.partyJoinInfo.rtilCode,
            rtilCode,
            id: item.id
          };
          this.axios.post('/partyline-backend/pushToTalk/noLogin/removeGroupInfo', params).then(res => {
            if (res.data.errorCode === '0x0') {
              this.participantsSort(item);
              item.rtilCodeList = item.rtilCodeList.filter(item => item !== rtilCode);
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
    },
    dealAllGroupArray(item) {
      this.allGroupArray = this.groupArray.filter(groupItem => groupItem.groupName !== item.groupName);
    },
    sendMoveParticipant(groupItem, rtilCode, item) {
      groupItem.select = !groupItem.select;
      if (this.moveParticipantTimer) clearTimeout(this.moveParticipantTimer);
      this.moveParticipantTimer = setTimeout(() => {
        const params = {
          partyCode: this.State.partyJoinInfo.joinCode,
          startRtilCode: this.State.partyJoinInfo.rtilCode,
          groupNameList: this.groupArray.filter(item => item.select).map(item => item.groupName),
          rtilCode,
          oldGroupName: item.groupName,
          oldId: item.id,
          id: groupItem.id
        };
        this.axios.post('/partyline-backend/pushToTalk/noLogin/batchMoveRtilCode', params).then(res => {
          if (res.data.errorCode === '0x0') {
            this.getAllGroup();
          }
        });
      }, 1000);
    },
    filterCreateParticipantList(inputVal) {
      if (inputVal) {
        this.participantList = this.participantList.filter(item => {
          return this.State.globalNameInfo[item.rtilCode].includes(inputVal);
        });
      } else {
        this.participantList = this.selectParticipantList;
      }
    },
    filterParticipantList(val, item) {
      if (val) {
        item.allRtilCodes = item.allRtilCodes.filter(rtilCode => this.State.globalNameInfo[rtilCode].includes(val));
      } else {
        item.allRtilCodes = this.State.allRtilCodes;
      }
    },
    showShortCutTips(index) {
      return this.$t('pushTalk.shortCut', {
        index: index + 1
      });
    }
  }
};